import type { Venue } from '@cocoonspace/sdk-js/types/venue'
import { track as vercelTrack } from '@vercel/analytics'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
	HomeBreadcrumbItem,
} from '~/components/ui/breadcrumb'
import { useTracking } from '~/providers/tracking-provider'

export const AdresseBreadcrumb = ({
	venue,
}: {
	venue: Venue
}) => {
	const { track } = useTracking()

	return (
		<Breadcrumb>
			<BreadcrumbList className='min-w-0 flex-nowrap'>
				<HomeBreadcrumbItem
					onClick={() => {
						track.click('breadcrumb-link', { route: '/' })
						vercelTrack('click-breadcrumb-link', { target: '/' })
					}}
				/>

				<BreadcrumbSeparator />

				<BreadcrumbItem>
					<BreadcrumbLink
						href={`/${venue?.zone}`}
						className='capitalize'
						onClick={() => {
							track.click('breadcrumb-link', { route: `/${venue?.zone}` })

							vercelTrack('click-breadcrumb-link', {
								target: `/${venue?.zone}`,
							})
						}}
					>
						{venue?.zone}
					</BreadcrumbLink>
				</BreadcrumbItem>

				<BreadcrumbSeparator />

				<BreadcrumbItem className='min-w-0 truncate'>
					<BreadcrumbPage className='truncate'>{venue?.title}</BreadcrumbPage>
				</BreadcrumbItem>
			</BreadcrumbList>
		</Breadcrumb>
	)
}
